import React, { useEffect, useState } from "react";
import './sdTimePicker.scss';
import up from './img/up.png';
import down from './img/down.png';
import { forZero } from "./gloFunc";

function SDTimePicker (props) {
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0)

  useEffect(() => {
    if (props.changeTime) {
      props.changeTime(`${forZero(hour)}:${forZero(minute)}`)
    }
  }, [hour, minute])

  function changeHour(i) {
    let th = hour + i;
    if (th > 23) th = 0;
    else if (th < 0) th = 23;
    setHour(th);
  }

  function changeMinute(i) {
    let tm = minute + i;
    if (tm > 59) {
      tm = 0
      changeHour(1);
    }
    else if (tm < 0) {
      tm = 59
      changeHour(-1);
    }
    setMinute(tm);
  }

  return (<div className="timePicker">
      <div className="tplabel">{props.label}</div>
      <div className="hourBlock">
        <div className="tpBtn" onClick={() => changeHour(-1)} style={{backgroundImage: `url(${up})`}}></div>
        <div className="tpValue">{hour}</div>
        <div className="tpBtn" onClick={() => changeHour(1)} style={{backgroundImage: `url(${down})`}}></div>
      </div>
      <div>:</div>
      <div className="minuteBlock">
        <div className="tpBtn" onClick={() => changeMinute(-1)} style={{backgroundImage: `url(${up})`}}></div>
        <div className="tpValue">{minute}</div>
        <div className="tpBtn" onClick={() => changeMinute(1)} style={{backgroundImage: `url(${down})`}}></div>
      </div>
  </div>);
}

export default SDTimePicker;